import React, { useEffect, useState } from 'react';
import { Modal, Spin, Typography } from 'antd';
import { EnvironmentOutlined } from '@ant-design/icons';
import CubaMap from '../mapa/CubaMap';
import { geocodeAddress } from './geocodeService';
import { useTranslation } from "react-i18next";

const SelectCoordinatesModal = ({ isVisible, onClose, onSelectCoordinates, data }) => {
    const { t } = useTranslation();
    const [coordinates, setCoordinates] = useState(null);

    const address = `${data.cmunicipality}. ${data.cprovince}`;

    useEffect(() => {
        if (isVisible) {
            setCoordinates(null);

            if (data.latitude && data.longitude) {
                // Si ya existen las coordenadas en `data`, las usamos directamente
                setCoordinates([data.latitude, data.longitude]);
            } else if (address) {
                // Si no, hacemos geocodificación para obtenerlas a partir de la dirección
                geocodeAddress(address).then((coords) => {
                    if (coords) {
                        setCoordinates(coords);
                    } else {
                        console.error("No se pudieron obtener coordenadas para la dirección proporcionada.");
                    }
                });
            }
        }
    }, [isVisible, address, data.latitude, data.longitude]);

    return (
        <Modal
            title={null}
            open={isVisible}
            onCancel={onClose}
            footer={null}
            width="95%"
            style={{
                top: 10,
                height: 'calc(100vh - 20px)',
                maxHeight: 'calc(100vh - 20px)'
            }}
            styles={{
                content: {
                    padding: 0,
                    borderRadius: '12px',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
                    overflow: 'hidden',
                    height: '100%'
                },
                body: {
                    padding: 0,
                    height: 'calc(100vh - 60px)',
                    display: 'flex',
                    flexDirection: 'column'
                }
            }}
        >
            {/* Header */}
            <div style={{
                background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                padding: '24px',
                color: 'white',
                textAlign: 'center',
                flexShrink: 0
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '16px'
                }}>
                    <div style={{
                        background: 'rgba(255,255,255,0.2)',
                        borderRadius: '50%',
                        width: '48px',
                        height: '48px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '20px'
                    }}>
                        <EnvironmentOutlined />
                    </div>
                    <div style={{ textAlign: 'left' }}>
                        <Typography.Title level={3} style={{
                            color: 'white',
                            margin: 0,
                            fontSize: '24px'
                        }}>
                            {t('map.title')}
                        </Typography.Title>
                        <Typography.Text style={{
                            color: 'rgba(255,255,255,0.8)',
                            fontSize: '14px',
                            display: 'block',
                            marginTop: '4px'
                        }}>
                            Factura: {data?.code || ''} - Seleccionar coordenadas en el mapa
                        </Typography.Text>
                    </div>
                </div>
            </div>

            {/* Address Info */}
            <div style={{
                background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                padding: '16px 24px',
                borderBottom: '1px solid #e0e6ff',
                flexShrink: 0
            }}>
                <Typography.Text style={{
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#253289',
                    display: 'block'
                }}>
                    📍 {t('map.address')}: {data?.address || ''}
                </Typography.Text>
                <Typography.Text style={{
                    fontSize: '14px',
                    color: '#666',
                    marginTop: '4px',
                    display: 'block'
                }}>
                    {data?.cmunicipality}, {data?.cprovince}
                </Typography.Text>
            </div>

            {/* Map Content */}
            <div style={{
                flex: 1,
                minHeight: 0,
                background: 'white',
                display: 'flex',
                flexDirection: 'column'
            }}>
                {/* Mostrar un spinner mientras se cargan las coordenadas */}
                {coordinates ? (
                    <div style={{
                        flex: 1,
                        overflow: 'hidden',
                        height: '100%',
                        minHeight: 0
                    }}>
                        <CubaMap
                            center={coordinates}  // Centrar el mapa en las coordenadas
                            markerPosition={coordinates}  // Colocar el marcador en las coordenadas
                            onCoordinatesSelect={onSelectCoordinates}
                            data={data}
                            onClose={onClose}
                        />
                    </div>
                ) : (
                    <div style={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        gap: '16px'
                    }}>
                        <Spin size="large" />
                        <Typography.Text style={{ color: '#666', fontSize: '16px' }}>
                            {t('global.loading')} coordenadas...
                        </Typography.Text>
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default SelectCoordinatesModal;